import { render } from "./ConfirmedOrders.vue?vue&type=template&id=5cbdd41c&scoped=true"
import script from "./ConfirmedOrders.vue?vue&type=script&lang=js"
export * from "./ConfirmedOrders.vue?vue&type=script&lang=js"

import "./ConfirmedOrders.vue?vue&type=style&index=0&id=5cbdd41c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbdd41c"]])

export default __exports__